import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth-guard.service';
import { AllowedRoles } from '../core/guards/allowed-roles.guard';
import { OktaRoles } from '../core/services/auth.service';
import { VendorsComponent } from './vendors.component';
import { FeatureFlagGuard } from '../core/guards/feature-flag.guard';
import { FeatureFlagNames } from '../core/services/feature-flag/feature-flag.types';

const routes: Routes = [
    {
        path: 'vendors',
        component: VendorsComponent,
        canActivate: [AuthGuard, AllowedRoles, FeatureFlagGuard],
        data: {
            AllowedRolesData: {
                oneOfRoles: [OktaRoles.vendorRead, OktaRoles.vendorEdit, OktaRoles.vendorApprove, OktaRoles.adminRead],
            },
            featureFlag: FeatureFlagNames.intappsVendors,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class VendorsRoutingModule {}
